import { defineRouting } from 'next-intl/routing';
import { runtimeConfig } from '@/config/runtime-config';
import { appLocales, defaultAppLocale } from './locales';

export const routing = defineRouting({
  locales: appLocales,
  defaultLocale: defaultAppLocale,
  localePrefix: 'as-needed',
  localeDetection: !runtimeConfig.defaultLanguage,
});
